import axios from 'axios';
import config from 'commons-vehicle/config/index.js';

import { HTTPService, ConfigsService, LocaleService } from '@sm360/widget-commons-core-services';
import ShowroomService from 'commons-vehicle/services/ShowroomService/ShowroomService.js';

class ShowroomAPIService {
    constructor() {
        this.basePath = `${config.endpoint.showroom}/service/v1`;
    }

    getPublicToken() {
        return axios.get(`${this.basePath}/jwt?userName=public&password=public`);
    }

    saveQuote(quote, token, quoteContext) {
        if (!quote || !token) {
            return Promise.reject(HTTPService.formatRejectResponse('missing parameters'));
        }

        const orgId = ConfigsService.getOrganizationId();
        const orgUnitId = ConfigsService.getOrganizationUnitId();
        const location = ConfigsService.getOrganizationUnitLocation().toLowerCase();
        const locale = LocaleService.getLocale();

        let context = `refresh=1&location=${location}&datalevel=1&context=${orgId}.${orgUnitId}&language=${locale}`;

        if (quote.securityToken) {
            context += `&securityToken=${quote.securityToken}`;
        }

        if (quoteContext) {
            context += `&${quoteContext}`;
        }

        return axios.put(`${this.basePath}/Quote?${context}`, quote, { headers: { 'x-jwt': token } }).then((result) => {
            return Promise.resolve(result.data);
        });
    }

    deleteQuote(quote, token) {
        const orgId = ConfigsService.getOrganizationId();
        const orgUnitId = ConfigsService.getOrganizationUnitId();
        const location = ConfigsService.getOrganizationUnitLocation().toLowerCase();
        // TO get updated quote data
        return ShowroomService.loadQuotesV25().then((accountQuotes) => {
            const quoteToDelete = accountQuotes.find((accountQuote) => quote.id === accountQuote.id);
            const { id, leadId, accountId, quoteRevision } = quoteToDelete;
            const context = `orgId=${orgId}&orgUnitId=${orgUnitId}&location=${location}`;
            const body = {
                id,
                leadId,
                accountId,
                location,
                quoteRevision,
                status: 'deleted',
            };
            return axios
                .post(`${this.basePath}/quote/desking/setStatus/${quote.id}?${context}`, body, {
                    headers: { 'x-jwt': token },
                })
                .then((result) => {
                    return Promise.resolve(result.data);
                });
        });
    }
}

export default new ShowroomAPIService();
